import React, { useState } from 'react';
import {
		Table,
		Popup,
		Button,
		Menu,
		Dropdown,
		Input,
		Loader,
		Icon,
		Container,
		Segment,
		Header,
		Confirm,
		TextArea,
		Form
	} from 'semantic-ui-react'
import EditScript from 'views/admin/scripts/EditScript'


const Edit = ({row, index, onUpdate}) => {
	
	const [show, setShow] = useState(false)
	const [showCons, setShowCons] = useState(false)
	
	return <>
				<Popup
						trigger={<Button 
								icon='edit'
								onClick={ _=> setShow({edit_win:!show}) }
								color={show&&'red'||undefined}
							/>}
						open = {!!show}
						position='left center'
						// on='click'
						style={{height: '80%', width: '80%', minWidth: 700, overflow: 'scroll'}}
				>
					<Popup.Header>
						<Icon 
								link 
								name='close' 
								style={{float:'right'}} 
								onClick={_=>setShow(false)} 
							/>
					</Popup.Header>
					<EditScript 
							scr_data={row} 
							onChange={onUpdate}
						/>
				</Popup>

			{['subcons', 'doccons'].includes(row.script_type) && ['noans_doccall', 'await_doccall'].includes(row.status) &&
				<>
				<br />
				<br />

				<Popup
						trigger={<Button 
								icon='doctor'
								onClick={ _=> setShowCons({edit_win:!showCons}) }
								color={'blue'}
							/>}
						open = {!!showCons}
						position='left center'
						// on='click'
						style={{height: '80%', width: '80%', minWidth: 700, overflow: 'scroll'}}
				>
					<Popup.Header>
						<Icon 
								link 
								name='close' 
								style={{float:'right'}} 
								onClick={_=>setShowCons(false)} 
							/>
					</Popup.Header>
				</Popup>
				</>
			}
		</>
};

export default Edit
